import { render } from "./SelectCategory.vue?vue&type=template&id=3856d0e3&scoped=true"
import script from "./SelectCategory.vue?vue&type=script&lang=js"
export * from "./SelectCategory.vue?vue&type=script&lang=js"

import "./SelectCategory.vue?vue&type=style&index=0&id=3856d0e3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3856d0e3"]])

export default __exports__